import { type PfpRoomPurpose, type RoomDto } from "./generated/CrowdcoursingApiSchemas";

export type { PfpRoomPurpose };

export const PFP_ROOM_PURPOSE = {
  Classroom: 2,
  Program: 0,
  Worksite: 1,
} as const satisfies Record<string, PfpRoomPurpose>;

export type PfpRoomPurposeLabel = "Program workspace" | "Worksite" | "Classroom";

export function getPfpRoomPurposeLabel(purpose?: PfpRoomPurpose | null): PfpRoomPurposeLabel | null {
  switch (purpose) {
    case PFP_ROOM_PURPOSE.Program:
      return "Program workspace";
    case PFP_ROOM_PURPOSE.Worksite:
      return "Worksite";
    case PFP_ROOM_PURPOSE.Classroom:
      return "Classroom";
    case undefined:
    case null:
      return null;
    default:
      purpose satisfies never;
      return null;
  }
}

export function isPfpWorksiteRoom(room?: RoomDto | null) {
  return room?.pfpRoomPurpose === PFP_ROOM_PURPOSE.Worksite;
}
